module.exports = __webpack_public_path__ + "img/852.8b8b9789.png";